import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Phase 17: Step 0 - Welcome Hero Screen
 * Apple-style welcome with animation
 */
function Step0Welcome() {
  const navigate = useNavigate();

  useEffect(() => {
    // Trigger entrance animations
    const timer = setTimeout(() => {
      document.querySelectorAll('.delayed-fade').forEach((el, idx) => {
        setTimeout(() => {
          el.classList.add('opacity-100');
          el.classList.remove('opacity-0');
        }, idx * 150);
      });
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full max-w-2xl mx-auto text-center animate-fade-in">
      {/* Main Icon/Logo */}
      <div className="mb-8 animate-scale-in">
        <div className="inline-flex items-center justify-center w-32 h-32 rounded-full bg-white/20 backdrop-blur-xl border-4 border-white/30 shadow-2xl">
          <span className="text-7xl">💙</span>
        </div>
      </div>

      {/* Welcome Text */}
      <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 delayed-fade opacity-0 transition-all duration-700">
        Willkommen bei Hayat
      </h1>
      
      <p className="text-xl sm:text-2xl text-white/90 font-medium mb-12 delayed-fade opacity-0 transition-all duration-700 px-4">
        Gemeinsam für unsere Liebsten.
      </p>

      {/* CTA Button */}
      <button
        onClick={() => navigate('/onboarding/step1')}
        className="delayed-fade opacity-0 transition-all duration-700 px-12 py-5 bg-white text-hayat-primary-600 rounded-3xl font-bold text-lg shadow-2xl hover:scale-105 hover:shadow-3xl active:scale-95 transition-transform duration-300"
      >
        Los geht's 🚀
      </button>

      {/* Subtle tagline */}
      <p className="mt-12 text-white/60 text-sm delayed-fade opacity-0 transition-all duration-700">
        Ihre Familie. Ihre Sicherheit. Ihr Vertrauen.
      </p>
    </div>
  );
}

export default Step0Welcome;